import { gql } from '@apollo/client/core';

export const FOLLOW_TEACHER = gql`
  mutation FollowTeacher($model: TeacherFollowerInput) {
    Teacher {
      FollowTeacher(model: $model) {
        Result {
          TeacherId
          StudentId
          ParentId
        }
      }
    }
  }
`;
